import * as React from 'react';
import ReactDOM from 'react-dom';
import { Spinner } from 'fabric-spinner';

const styles = require('./FullScreenSpinner.scss');

const FullScreenSpinner = ({}) => (
    <div className={styles.container}>
        <Spinner className={styles.spinner} />
    </div>
);

let fullScreenSpinnerDiv: HTMLDivElement;

export function showFullScreenSpinner() {
    if (fullScreenSpinnerDiv) {
        return;
    }

    fullScreenSpinnerDiv = document.createElement('div');
    fullScreenSpinnerDiv.id = 'fullScreenSpinner';
    document.body.appendChild(fullScreenSpinnerDiv);

    ReactDOM.render(<FullScreenSpinner />, fullScreenSpinnerDiv);
}

export function hideFullScreenSpinner() {
    if (fullScreenSpinnerDiv) {
        ReactDOM.unmountComponentAtNode(fullScreenSpinnerDiv);
        document.body.removeChild(fullScreenSpinnerDiv);
        fullScreenSpinnerDiv = null;
    }
}
